import { render, staticRenderFns } from "./QARejectionModal.vue?vue&type=template&id=db50d506&scoped=true&"
import script from "./QARejectionModal.vue?vue&type=script&lang=js&"
export * from "./QARejectionModal.vue?vue&type=script&lang=js&"
import style0 from "./QARejectionModal.vue?vue&type=style&index=0&id=db50d506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db50d506",
  null
  
)

export default component.exports